import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Home from './pages/Home'
import Dashboard from './pages/Dashboard'
import Library from './pages/Library'
import Player from './pages/Player'
import Upload from './pages/Upload'
import SharedDrive from './pages/SharedDrive'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import DeviceInfoPage from './pages/DeviceInfo'
import UserBadge from './components/UserBadge'
import { initAutoTracking, trackEvent } from './lib/tracking'
import { handleGoogleCallback } from './lib/googleAuth'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function App() {
  useEffect(() => {
    initAutoTracking()
    const user = handleGoogleCallback()
    if (user) {
      trackEvent('google_auth_success', { email: user.email, name: user.name })
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserBadge />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nepali_compiled_videos" element={<SharedDrive />} />
          <Route path="/drive/:id" element={<SharedDrive />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/library" element={<Library />} />
          <Route path="/player/:id" element={<Player />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/device-info" element={<DeviceInfoPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
